import React from 'react';

const Policy = () => {
  return (
    <div className='flex flex-col gap-5 items-center justify-center min-h-screen'>
      <div className='flex flex-col p-5 my-32 bg-white rounded-xl max-w-[80%] min-h-[40%] shadow-2xl border-2 border-black'>
      <div className="container11">
        <div className="row11">
          <h2 className='text-purple-500 text-2xl font-bold mb-3 mt-5'>PLAGIARISM POLICY</h2>
          <p className="aimtext311">
            Plagiarism is when an author attempts to pass off someone else's
            work as his or her own. Duplicate publication, sometimes called
            self-plagiarism, occurs when an author reuses substantial parts of
            his or her own published work without providing the appropriate
            references. <br /> This can range from getting an identical paper
            published in multiple journals, to salami-slicing, where authors add
            small amounts of new <br /> data to a previous paper. <br />
            <br />
            <b>PLAGIARISM PRIOR PUBLISHING:</b> <br /> <br />
            <b>
              BODH: IJETEM's International Journal of Technology and Management
            </b>{" "}
            will judge any case of plagiarism on its limits. If plagiarism is
            detected by the editorial board member, reviewer, editor, etc., in
            any stage of the article process—before or after acceptance—then we
            will alert the author(s) and ask them to rewrite the content or cite
            the references from where the content has been taken. If more than
            30% of the paper is plagiarized, the article may be rejected, and
            the same is notified to the author.
            <br /> <br />
            <b>WHEN DOES THE PLAGIARISM CHECK DONE?</b> <br />
            All the submitted manuscripts for publication are checked for
            plagiarism after submission and before starting the review.
            <br />
            <br /> <b>HOW IS PLAGIARISM HANDLED?</b> <br />
            The manuscripts in which plagiarism is detected are handled based on
            the extent of the plagiarism. `{">"}`5% <br />
            <b>Plagiarism:</b> The manuscript will be given an ID, and the
            manuscript is sent to the author for content revision.
            <br /> <b>5- 30% Plagiarism:</b> The manuscript will not be given an
            ID, and the manuscript is sent back to the author for content
            revision.
            <br /> <b> `{">"}`30% Plagiarism:</b> The manuscript will be
            rejected without the review. The authors are advised to revise the
            manuscript and resubmit it.
            <br />
            <br />{" "}
            <b>WHY ARE MANUSCRIPTS WITH `{">"}`30% PLAGIARISM REJECTED?</b>{" "}
            <br />
            If plagiarism is detected more than 30%, it is found that the
            authors are very unlikely to revise the manuscript and submit the
            revised version. However, authors are welcome to do the required
            revisions and submit the manuscript as a new submission.
            <br />
            <br />{" "}
            <b>
              {" "}
              WHAT CAN YOU DO IF YOU COME ACROSS A CASE OF PLAGIARISM IN ANY
              JOURNAL FROM ANY PUBLISHER?
            </b>{" "}
            <br />
            If you come across a case of plagiarism in any journal from any
            publisher, please inform the editorial office(s) of all the involved
            journals, giving them the journal names, title of manuscripts, name
            of authors, volume number, issue number, year of publication, and
            any other information that you have. The editorial offices will
            handle the cases as per their policy.
            <br />
            <br /> <b>WHAT IF PLAGIARISM IS DETECTED AFTER PUBLICATION</b>{" "}
            <br />
            If a case of plagiarism comes to light after a paper is published in
            a Scholarena journal, the journal will conduct a preliminary
            investigation. If plagiarism is found, the journal will contact the
            author's institute and funding agencies. A determination of
            misconduct will lead the Scholarena journal to run a statement,
            bidirectionally linked online to and from the original paper, to
            note the plagiarism and provide a reference to the plagiarized
            material. The paper containing the plagiarism will also be obviously
            marked on each page of the PDF. Depending on the extent of the
            plagiarism, the paper may also be formally retracted.
            <br />
            <br /> <b>ORIGINALITY</b> <br />
            By submitting author(s) manuscript to the journal, it is understood
            that it is an original manuscript and is unpublished work and is not
            under consideration elsewhere. Plagiarism, including duplicate
            publication of the author's own work, in whole or in part without
            proper citation, is not tolerated by the journal. Manuscripts
            submitted to the journal may be checked for originality using
            anti-plagiarism software. <br />
            Plagiarism misrepresents ideas, words, and other creative
            expressions as one's own. Plagiarism represents the violation of
            copyright law. Plagiarism appears in various forms. <br />
            Copying the exact content from another source. Purposely using
            portions of another author's paper. <br />
            Copying elements of another author's paper, such as figures, tables,
            equations, or illustrations that are not common knowledge, or
            copying or purposely using sentences without citing the source.{" "}
            <br />
            Using text downloaded from the internet. <br />
            Copying or downloading figures, photographs, pictures, or diagrams
            without acknowledging your sources. <br />
            In the case of a publication being submitted that was originally
            published in another language, the title, date, and journal of the
            original publication must be identified by the authors, and the
            copyright must be obtained. The editor may accept such a translated
            publication to bring it to the attention of a wider audience. <br />
            In case an author wants to use material from another work, then it
            is mandatory to cite the same in references. Else, the author needs
            to change the language completely and use his/her own language.
            <br />
            <br />
            <b>ACKNOWLEDGING AUTHOR(S) SOURCES</b> <br />
            Self-plagiarism is a related issue. In this document, we define
            self-plagiarism as the verbatim or near-verbatim reuse of
            significant portions of one's own copyrighted work without citing
            the original source. Note that self-plagiarism does not apply to
            publications based on the author's own previously copyrighted work
            (e.g., appearing in a conference proceedings) where an explicit
            reference is made to the prior publication. Such reuse does not
            require quotation marks to delineate the reused text but does
            require that the source be cited.
          </p>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Policy;
